module.exports = __webpack_public_path__ + "static/weronikawork6-88f864b4eb1d61cb009b605acc2d884f.jpg";